module.exports = __webpack_public_path__ + "img/placeholder-white.5d649b6a.svg";